import { GET_QUESTION_OPTIONS, SET_QUESTION_OPTIONS } from "./QuestionOptionTypes";


const getQuestionOptions = () => {
    return {
        type: GET_QUESTION_OPTIONS
    }
}

const setQuestionOptions = (response:any) => {
    return {
        type: SET_QUESTION_OPTIONS,
        payload: response
    }
}

export {
    getQuestionOptions,
    setQuestionOptions
}